<template>
  <div
    :class="{ 'is-expanded': type === 'Trading', 'modal-card confirm-modal': type === 'BuySellModal' }"
    data-test="trading--trading-card"
  >
    <div
      v-if="type === 'BuySellModal'"
      class="modal-header"
      data-test="trading--trading-header"
    >
      <p class="modal-header-text">{{ $t('exchange.buy_sell_token').toUpperCase() }}</p>
      <div
        class="modal-header-close-btn"
        @click="$parent.close()"
      >
        <img src="/static/svg/close-symbol.svg">
      </div>
    </div>
    <div
      :class="{ 'modal-body': type === 'BuySellModal' }"
      data-test="trading--trading-body"
    >
      <Exchange
        :from-token="fromTokenSelected"
        :to-token="toTokenSelected"
        :input-from="fromTokenInput"
        :input-to="toTokenInput"
        :best-rate="currentBestRate"
        :theme="type === 'Trading' ? 'blue' : 'white'"
        :is-from-amount-too-high-type="isFromAmountTooHighType"
        @typeOnFormTokenInput="typeOnFormTokenInput"
        @typeOnToTokenInput="typeOnToTokenInput"
        @switchToken="switchToken"
        @changeSpeedOfTx="changeSpeedOfTx"
        @openSelectTokenModal="openSelectTokenModal"
        @clearAllData="clearAllData"
        @exchange="exchange"
      />
    </div>
  </div>
</template>

<script>
import Service from './service.js'
import KulapService from '@/services/kulap'
import { kulapApi } from '@/resources'
import bignumber from '@/utils/bignumber'
import Exchange from '@/components/Exchange'
import ConfirmModal from '@/components/ConfirmModal'
import SelectTokenModal from '@/components/SelectTokenModal'
import OnProcessModal from '@/components/OnProcessModal'
import TradeResultModal from '@/components/TradeResultModal'
import AllowExchangeModal from '@/components/AllowExchangeModal'
import RequestObjectiveOfTradingModal from '@/components/RequestObjectiveOfTradingModal'
import LoginModal from '@/features/LoginModal'
import AlertEventNotPass from '@/components/AlertEventNotPass'
import { getEterScanUrl } from '@/environments'
import { mapGetters, mapState, mapActions } from 'vuex'
import {
  BIGNUMBER_ZERO,
  ENV,
  KULAP_MAINNET_ADDR,
  KULAP_KOVAN_ADDR,
  DEFAULT_PRICE_SLIPPAGE,
  PLATFORM_FEE
} from '@/constants'

export default {
  name: 'Trading',
  components: {
    Exchange,
    SelectTokenModal,
    LoginModal,
    AlertEventNotPass,
    RequestObjectiveOfTradingModal
  },
  props: {
    type: {
      type: String,
      default: 'Trading' // ['BuySellModal', 'Trading']
    },
    modalFromToken: {
      type: Object,
      default: () => {}
    },
    modalToToken: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      // Set default `from token`
      fromTokenCodeSelected: {
        code: 'ETH',
        balance: BIGNUMBER_ZERO
      },
      // Set default `to token`
      toTokenCodeSelected: {
        code: process.env.ETH_NETWORK === 'kovan' ? 'DAI-UNI' : 'DAI',
        balance: BIGNUMBER_ZERO
      },
      env: ENV,
      fromTokenInput: '',
      toTokenInput: '',
      inputDelayTimer: null,
      isSelectFromTokenModalActive: false,
      isSelectToTokenModalActive: false,
      speedOfTx: 'STD',
      confirmModal: null,
      onProcessModal: null,
      approveTokenModal: null,
      requestObjectiveOfTradingModal: null,
      txsCreated: {},
      etherScanUrl: '',
      service: null,
      isFromAmountTooHighType: 'ENOUGH',
      maxPriceSlippage: DEFAULT_PRICE_SLIPPAGE,
      platformFee: PLATFORM_FEE
    }
  },
  computed: {
    ...mapState({
      currentBestRate: state => state.currentBestRate,
      currentNetwork: state => state.currentNetwork,
      currentWalletProvider: state => state.currentWalletProvider,
      user: state => state.user,
      currentWeb3: state => state.currentWeb3,
      getBestRateCount: state => state.getBestRateCount
    }),
    ...mapGetters({
      tokensForTrade: 'tokensForTrade',
      userDefaultWallet: 'userDefaultWallet'
    }),
    sortTokenByUsdValue () {
      if (this.tokensForTrade.length) {
        const result = this.tokensForTrade.map(token => {
          return {
            ...token,
            usdValue: bignumber(token.rateUsd).multipliedBy(token.balance)
          }
        }).sort((first, sec) => sec.usdValue - first.usdValue)
        return result
      } else {
        return []
      }
    },
    fromTokenSelected () {
      if (this.tokensForTrade.length) {
        const tokenCode = this.fromTokenCodeSelected.code
        return this.tokensForTrade.find(t => t.code === tokenCode)
      } else {
        return this.fromTokenCodeSelected
      }
    },
    toTokenSelected () {
      if (this.tokensForTrade.length) {
        const tokenCode = this.toTokenCodeSelected.code
        return this.tokensForTrade.find(t => t.code === tokenCode)
      } else {
        return this.toTokenCodeSelected
      }
    }
  },
  watch: {
    async userDefaultWallet (value, oldValue) {
      console.log('userDefaultWallet from', oldValue)
      console.log('userDefaultWallet to', value)
      if (value && oldValue) {
        await this.clearAllData()
      }
    }
  },
  async created () {
    const kulapDex = new KulapService()
    await kulapDex.init()
    this.service = new Service({ kulapApi, kulapDex, store: this.$store })
  },
  mounted () {
    this.fromTokenCodeSelected = this.type === 'BuySellModal' ? this.modalFromToken : this.fromTokenCodeSelected
    this.toTokenCodeSelected = this.type === 'BuySellModal' ? this.modalToToken : this.toTokenCodeSelected
  },
  methods: {
    ...mapActions({
      setCurrentBestRate: 'setCurrentBestRate'
    }),
    clearAllData () {
      console.log('clearAllData')
      this.fromTokenInput = ''
      this.toTokenInput = ''
    },
    switchToken () {
      console.log('switchToken')
      console.log('this.fromTokenCodeSelected', this.fromTokenCodeSelected)
      console.log('this.toTokenCodeSelected', this.toTokenCodeSelected)
      this.setCurrentBestRate({})
      this.service.cancelGetBestRate()
      const tempFromTokenSelected = this.fromTokenCodeSelected
      this.fromTokenCodeSelected = this.toTokenCodeSelected
      this.toTokenCodeSelected = tempFromTokenSelected
      if (this.fromTokenInput) {
        this.findBestRateFromAmount(this.fromTokenInput)
      }
    },
    openSelectTokenModal (type) {
      this.$buefy.modal.open({
        parent: this,
        component: SelectTokenModal,
        hasModalCard: true,
        props: {
          tokens: this.sortTokenByUsdValue,
          tokenSelectedCode: type === 'from' ? this.fromTokenSelected.code : this.toTokenSelected.code
        },
        events: {
          select: type === 'from' ? this.selectFromToken : this.selectToToken
        },
        canCancel: ['escape', 'outside']
      })
    },
    selectFromToken (token) {
      console.log('selectFromToken', token)
      this.setCurrentBestRate({})
      this.service.cancelGetBestRate()
      if (token.code === this.toTokenCodeSelected.code) {
        this.switchToken()
      } else {
        this.fromTokenCodeSelected = token
        if (this.fromTokenInput) {
          this.findBestRateFromAmount(this.fromTokenInput)
        }
      }
    },
    selectToToken (token) {
      console.log('selectToToken', token)
      this.setCurrentBestRate({})
      this.service.cancelGetBestRate()
      if (token.code === this.fromTokenCodeSelected.code) {
        this.switchToken()
      } else {
        this.toTokenCodeSelected = token
        if (this.fromTokenInput) {
          this.findBestRateFromAmount(this.fromTokenInput)
        }
      }
    },
    changeSpeedOfTx (val) {
      this.speedOfTx = val
    },
    typeOnFormTokenInput (value) {
      if (value === this.fromTokenInput) {
        return
      }
      console.log('typeOnFormTokenInput', value)
      this.setCurrentBestRate({})
      this.service.cancelGetBestRate()
      this.fromTokenInput = value
      if (this.inputDelayTimer) {
        clearTimeout(this.inputDelayTimer)
      }
      if (!value || bignumber(value).isEqualTo(BIGNUMBER_ZERO) || isNaN(value)) {
        this.toTokenInput = ''
        this.setCurrentBestRate({})
        this.isFromAmountTooHighType = 'ENOUGH'
        return
      }
      this.inputDelayTimer = setTimeout(async () => {
        if (bignumber(value).isLessThanOrEqualTo(BIGNUMBER_ZERO)) {
          this.toTokenInput = ''
          this.setCurrentBestRate({})
        } else {
          this.findBestRateFromAmount(value)
        }
      }, 500)
    },
    typeOnToTokenInput (value) {
      if (value === this.toTokenInput) {
        return
      }
      console.log('typeOnFormTokenInput', value)
      this.setCurrentBestRate({})
      this.service.cancelGetBestRate()
      this.toTokenInput = value
      if (this.inputDelayTimer) {
        clearTimeout(this.inputDelayTimer)
      }
      if (!value || bignumber(value).isEqualTo(BIGNUMBER_ZERO) || isNaN(value)) {
        this.toTokenInput = ''
        this.setCurrentBestRate({})
        this.isFromAmountTooHighType = 'ENOUGH'
        return
      }
      this.inputDelayTimer = setTimeout(async () => {
        if (bignumber(value).isLessThanOrEqualTo(BIGNUMBER_ZERO)) {
          this.fromTokenInput = ''
          this.setCurrentBestRate({})
        } else {
          this.findBestRateToAmount(value)
        }
      }, 500)
    },
    async fetchBestRateFromAmount (fromBaseAmount) {
      this.$store.dispatch('increaseGetBestRateCount')
      const stampGetRateCount = this.getBestRateCount
      const bestRate = await this.service.getBestRateFromFromAmount(this.fromTokenSelected, this.toTokenSelected, bignumber(fromBaseAmount))
      if (stampGetRateCount === this.getBestRateCount) {
        this.$store.dispatch('setCurrentBestRate', bestRate)
      } else {
        throw new Error('RATE IS NOT CURRENT QUERY')
      }
    },
    async fetchBestRateToAmount (toBaseAmount) {
      this.$store.dispatch('increaseGetBestRateCount')
      const stampGetRateCount = this.getBestRateCount
      const bestRate = await this.service.getBestRateFromToAmount(this.fromTokenSelected, this.toTokenSelected, bignumber(toBaseAmount))
      if (stampGetRateCount === this.getBestRateCount) {
        this.$store.dispatch('setCurrentBestRate', bestRate)
      } else {
        throw new Error('RATE IS NOT CURRENT QUERY')
      }
    },
    async findBestRateFromAmount (fromBaseAmount) {
      try {
        console.log(`start get rate ${this.fromTokenSelected} -> ${this.toTokenSelected}`)
        this.toTokenInput = 'LOADING'
        await this.fetchBestRateFromAmount(fromBaseAmount)
        if (this.currentBestRate[this.speedOfTx]) {
          const bestPrice = bignumber(this.currentBestRate[this.speedOfTx].trade.toAmount).toBase(this.toTokenCodeSelected.decimal)
          this.toTokenInput = bestPrice.toString()
          this.verifyIsFromAmountTooHighType(fromBaseAmount)
        } else {
          console.log('rate not found, clear data')
          this.fromTokenInput = ''
          this.toTokenInput = ''
        }
      } catch (error) {
        if (error.message === 'REQUEST_CANCELD') {
          // Do nothing
        } else if (error.message === 'RATE IS NOT CURRENT QUERY') {
          console.log('rate is not current query')
        } else {
          this.throwErrorWhenFailFindBestRate(error)
        }
      }
    },
    async findBestRateToAmount (toBaseAmount) {
      try {
        console.log(`start get rate ${this.fromTokenSelected} -> ${this.toTokenSelected}`)
        this.fromTokenInput = 'LOADING'
        await this.fetchBestRateToAmount(toBaseAmount)
        if (this.currentBestRate[this.speedOfTx]) {
          const bestPrice = bignumber(this.currentBestRate[this.speedOfTx].trade.fromAmount).toBase(this.fromTokenCodeSelected.decimal)
          this.fromTokenInput = bestPrice.toString()
          this.verifyIsFromAmountTooHighType(this.fromTokenInput)
        } else {
          console.log('rate not found, clear data')
          this.fromTokenInput = ''
          this.toTokenInput = ''
        }
      } catch (error) {
        if (error.message === 'REQUEST_CANCELD') {
          // Do nothing
        } else if (error.message === 'RATE IS NOT CURRENT QUERY') {
          console.log('rate is not current query')
        } else {
          this.throwErrorWhenFailFindBestRate(error)
        }
      }
    },
    verifyIsFromAmountTooHighType (value) {
      const gasPrice = bignumber(this.currentBestRate[this.speedOfTx].gasPrice).toWei(9)
      const totalGas = bignumber(this.currentBestRate[this.speedOfTx].gasLimit.multipliedBy(gasPrice)).toBase(18)
      const balance = bignumber(this.fromTokenSelected.balance)
      if (bignumber(value).isGreaterThan(balance)) {
        this.isFromAmountTooHighType = 'NOT_ENOUGH'
      } else if (this.fromTokenSelected.code === 'ETH' && bignumber(value).plus(totalGas).isGreaterThan(balance)) {
        this.isFromAmountTooHighType = 'GAS_NOT_ENOUGH'
      } else {
        this.isFromAmountTooHighType = 'ENOUGH'
      }
    },
    throwErrorWhenFailFindBestRate (e) {
      this.$buefy.toast.open({
        message: `Cannot get best rate for this token.`,
        type: 'is-danger'
      })
      this.fromTokenInput = ''
      this.toTokenInput = ''
    },
    async exchange (data) {
      this.maxPriceSlippage = data.maxPriceSlippage
      if (this.env === 'insider') {
        this.openExchangeModal(data)
        return
      }
      if (Object.keys(this.user).length === 0) { // Not login yet
        this.$buefy.modal.open({
          parent: this,
          component: LoginModal,
          hasModalCard: true,
          canCancel: ['escape', 'outside', 'x'],
          events: {
            loginSuccess: async () => {
              await this.service.updateUserData()
              this.exchange(data)
            }
          }
        })
      } else if (
        !this.user.isActive ||
        this.user.kycStatus !== 'APPROVED' ||
        !this.user.hasOwnProperty('suitabilityTestPoint') ||
        !this.user.hasOwnProperty('knowledgeTestPoint')
      ) {
        this.$buefy.modal.open({
          parent: this,
          component: AlertEventNotPass,
          canCancel: ['escape', 'outside'],
          props: {
            isActive: this.user.isActive,
            isPassKyc: this.user.kycStatus === 'APPROVED',
            isSubmitSuitabilityTest: this.user.hasOwnProperty('suitabilityTestPoint'),
            isSubmitKnowledgeTest: this.user.hasOwnProperty('knowledgeTestPoint')
          }
        })
      } else {
        this.openExchangeModal(data)
      }
    },
    async openExchangeModal (data) {
      this.$emit('onClickExchange')
      let approved = true
      if (data.from.code !== 'ETH') {
        const isAllowanced = await this.service.isAllowanced(this.fromTokenSelected.address, this.userDefaultWallet)
        approved = isAllowanced
        if (!isAllowanced) {
          approved = await this.onApproveToken(data, this.fromTokenSelected.address, this.userDefaultWallet)
        }
      }
      if (approved) {
        this.onConfirmExchangeModal(data)
      }
    },
    onConfirmExchangeModal (data) {
      if (this.approveTokenModal) this.approveTokenModal.close()
      let kulapSmartContractAddr = ''
      if (this.currentNetwork === 'main') {
        kulapSmartContractAddr = KULAP_MAINNET_ADDR
      } else if (this.currentNetwork === 'kovan') {
        kulapSmartContractAddr = KULAP_KOVAN_ADDR
      }
      this.etherScanUrl = getEterScanUrl(this.currentNetwork)
      this.confirmModal = this.$buefy.modal.open({
        parent: this,
        component: ConfirmModal,
        hasModalCard: true,
        props: {
          source: this.fromTokenSelected,
          target: this.toTokenSelected,
          sourceAmount: bignumber(data.from.amount),
          targetAmount: bignumber(data.to.amount),
          gasPrice: bignumber(data.rate.gasPrice),
          txFee: bignumber(data.txFee),
          platformFee: this.platformFee,
          estimatedTime: data.estimatedTime,
          maxPriceSlippage: this.maxPriceSlippage,
          etherScanUrl: this.etherScanUrl,
          kulapSmartContractAddr
        },
        events: {
          onConfirm: async () => {
            this.service.kulapDex.web3 = this.currentWeb3
            await this.service.kulapDex.init()
            this.service.web3 = this.currentWeb3
            const isVolumeOverDailyLimit = await this.service.checkUserDailyVolume(
              this.userDefaultWallet,
              this.currentWalletProvider,
              this.fromTokenSelected.code,
              bignumber(data.from.amount).toWei(this.fromTokenSelected.decimals || this.fromTokenSelected.decimal).toString()
            )
            if (isVolumeOverDailyLimit) {
              this.openRequestObjectiveOfTradingModal(data)
            } else {
              await this.service.exchange(
                this.userDefaultWallet,
                this.fromTokenSelected,
                this.toTokenSelected,
                data.rate,
                this.maxPriceSlippage,
                this.onTransactionHash,
                this.onSuccess,
                this.onError,
                data
              )
            }
          }
        },
        canCancel: ['escape', 'outside']
      })
    },
    onTransactionHash (hash, dataForUI) {
      if (this.confirmModal) this.confirmModal.close()
      this.service.pushTransactionHistory('in progress', hash, this.currentNetwork, dataForUI, this.userDefaultWallet, this.currentNetwork)
      this.etherScanUrl = getEterScanUrl(this.currentNetwork)
      this.onProcessModal = this.$buefy.modal.open({
        parent: this,
        component: OnProcessModal,
        hasModalCard: true,
        props: {
          hash,
          etherScanUrl: this.etherScanUrl
        },
        canCancel: ['escape', 'outside']
      })
    },
    async onSuccess (receipt, dataForUI) {
      if (this.confirmModal) this.confirmModal.close()
      if (this.onProcessModal) this.onProcessModal.close()
      this.clearAllData()
      this.service.pushTransactionHistory('success', receipt.transactionHash, this.currentNetwork, dataForUI, receipt, this.userDefaultWallet, this.currentNetwork)
      this.etherScanUrl = getEterScanUrl(this.currentNetwork)
      const tx = await this.service.getTransaction(receipt.transactionHash)
      const txFee = bignumber(bignumber(receipt.gasUsed).multipliedBy(tx.gasPrice)).toBase(18)
      this.$buefy.modal.open({
        parent: this,
        component: TradeResultModal,
        hasModalCard: true,
        props: {
          status: 'success',
          source: dataForUI.from,
          target: dataForUI.to,
          sourceAmount: bignumber(dataForUI.from.amount),
          targetAmount: bignumber(receipt.events.Trade.returnValues.destAmount).toBase(dataForUI.to.decimals || dataForUI.to.decimal),
          rateEstimate: bignumber(dataForUI.rate.trade.rate),
          txFee: bignumber(txFee),
          platformFee: this.platformFee,
          hash: receipt.transactionHash,
          etherScanUrl: this.etherScanUrl
        },
        canCancel: ['escape', 'outside']
      })
      this.$emit('onCompleteTreading')
    },
    async onError (error, dataForUI) {
      if (this.confirmModal) this.confirmModal.close()
      if (this.onProcessModal) this.onProcessModal.close()
      this.service.pushTransactionHistory('fail', dataForUI.hash, this.currentNetwork, dataForUI, this.userDefaultWallet, this.currentNetwork)
      const receipt = await this.service.getTransactionReceipt(dataForUI.hash)
      this.etherScanUrl = getEterScanUrl(this.currentNetwork)
      const tx = await this.service.getTransaction(receipt.transactionHash)
      const txFee = bignumber(bignumber(receipt.gasUsed).multipliedBy(tx.gasPrice)).toBase(18)
      this.$buefy.modal.open({
        parent: this,
        component: TradeResultModal,
        hasModalCard: true,
        props: {
          status: 'fail',
          source: dataForUI.from,
          target: dataForUI.to,
          sourceAmount: bignumber(dataForUI.from.amount),
          targetAmount: bignumber(dataForUI.to.amount),
          rateEstimate: bignumber(dataForUI.rate.trade.rate),
          txFee: bignumber(txFee),
          platformFee: this.platformFee,
          hash: dataForUI.hash,
          etherScanUrl: this.etherScanUrl
        },
        canCancel: ['escape', 'outside']
      })
      console.error(error)
    },
    async onApproveToken (data, fromTokenAddr, userAddr) {
      return new Promise(async (resolve, reject) => {
        this.approveTokenModal = this.$buefy.modal.open({
          parent: this,
          component: AllowExchangeModal,
          hasModalCard: true,
          props: {
            code: data.from.code,
            name: data.from.name,
            userAddress: userAddr
          },
          events: {
            onConfirm: async () => {
              this.service.kulapDex.web3 = this.currentWeb3
              await this.service.kulapDex.init()
              this.service.web3 = this.currentWeb3
              this.approveTokenModal.close()
              const gasPrice = bignumber(data.rate.gasPrice).gweiToWei()
              const hash = await this.service.approveToken(fromTokenAddr, userAddr, gasPrice)
              if (hash) {
                resolve(true)
              } else {
                reject(new Error(false))
              }
            }
          },
          onCancel: () => {
            reject(new Error(false))
          },
          canCancel: ['escape', 'outside']
        })
      })
    },
    openRequestObjectiveOfTradingModal (data) {
      this.requestObjectiveOfTradingModal = this.$buefy.modal.open({
        parent: this,
        component: RequestObjectiveOfTradingModal,
        hasModalCard: true,
        props: {
          source: this.fromTokenSelected,
          target: this.toTokenSelected,
          sourceAmount: bignumber(data.from.amount),
          targetAmount: bignumber(data.to.amount),
          gasPrice: bignumber(data.rate.gasPrice),
          txFee: bignumber(data.txFee),
          estimatedTime: data.estimatedTime
        },
        events: {
          onSubmit: async (objective) => {
            const result = await this.service.sendObjectiveOfTrading(
              objective,
              this.fromTokenSelected.code,
              bignumber(data.from.amount).toWei(this.fromTokenSelected.decimals || this.fromTokenSelected.decimal).toString()
            )
            if (result && result.success) {
              await this.service.exchange(
                this.userDefaultWallet,
                this.fromTokenSelected,
                this.toTokenSelected,
                data.rate,
                this.maxPriceSlippage,
                this.onTransactionHash,
                this.onSuccess,
                this.onError,
                data
              )
            } else {
              this.$buefy.toast.open({
                message: `Sorry, can't send objective of trading, please try again.`,
                type: 'is-danger'
              })
            }
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.confirm-modal {
  float: left;
  width: 530px;
  background-color: #ffffff;
  border-radius: 5px;
  /* max-height: calc(100vh - 160px) !important; */
}
.modal-header {
  float: left;
  width: 100%;
  height: 60px;
  background-color: #0559af;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-header-text {
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.7px;
  color: #ffffff;
}
.modal-header-close-btn {
  position: absolute;
  top: 15px;
  right: 19px;
}
.modal-header-close-btn {
  cursor: pointer;
}
.modal-body {
  float: left;
  width: 100%;
  height: calc(100% - 60px);
  overflow-y: scroll;
}
.modal-content {
  width: 100%;
  float: left;
  margin: 0;
}

/* Mobile */
@media only screen and (max-width: 768px) {
  .confirm-modal {
    float: left;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/Trading/index.vue